export enum LockStage {
  BUY_TICKETS,
  CLAIM_TICKETS,
  DRAW_FINAL_NUMBER,
  BURN_TOKEN_FOR_CREDIT,
  WITHDRAW,
  INJECT_FUNDS,
  CLAIM_LOTTERY_REVENUE,
  CLOSE_LOTTERY,
  UPDATE_BURN_TOKEN_FOR_CREDIT,
  START_LOTTERY,
  ADMIN_WITHDRAW,
  ADD_TOKEN,
  UPDATE_LOCATION,
  UPDATE_NFT_PRIZES,
  CONFIRM_UPDATE_NFT_PRIZES,
  CONFIRM_UPDATE_LOCATION,
  CONFIRM_ADD_TOKEN,
  CONTRIBUTE_RANDOM_NUMBER_FEES,
  CONFIRM_BUY_TICKETS,
  CONFIRM_CLAIM_TICKETS,
  CONFIRM_DRAW_FINAL_NUMBER,
  CONFIRM_BURN_TOKEN_FOR_CREDIT,
  CONFIRM_WITHDRAW,
  CONFIRM_INJECT_FUNDS,
  CONFIRM_CLAIM_LOTTERY_REVENUE,
  CONFIRM_CLOSE_LOTTERY,
  CONFIRM_UPDATE_BURN_TOKEN_FOR_CREDIT,
  CONFIRM_START_LOTTERY,
  CONFIRM_ADMIN_WITHDRAW,
  CONFIRM_CONTRIBUTE_RANDOM_NUMBER_FEES,
  SETTINGS,
  ADMIN_SETTINGS,
  TX_CONFIRMED,
}
